import config from 'teacher-ui-client/config/environment'
import type AuthToken from '@blakeelearning/auth/services/auth-token'
import JSONAPIAdapter from '@ember-data/adapter/json-api'
import type Store from '@ember-data/store'
import { service } from '@ember/service'
import { adapterHostAndNamespace } from 'teacher-ui-client/utils/uri'

const url = new URL(config.gravityV3Url)
export const { host, namespace } = adapterHostAndNamespace(url)
export const baseUrl = url.href

export default class GravityV3Adapter extends JSONAPIAdapter {
  host = host

  namespace = namespace

  get baseUrl() {
    return baseUrl
  }

  @service authToken!: AuthToken

  // @ts-expect-error - parent defines this as a property, we override with getter
  get headers() {
    const { token } = this.authToken
    return {
      Authorization: token,
      Accept: 'application/vnd.api+json',
    }
  }

  // @ts-expect-error too annoying to fix
  query(
    store: Store,
    type: any,
    query: any,
    _recordArray: unknown,
    adapterOptions?: Record<string, any>,
  ): Promise<unknown> {
    /* Certain requests may have a lot of query params, causing a URL to exceed the length limits of browsers. In these
     * situations, we can opt to make the request via POST, which is capable of handling larger payloads.
     */

    if (adapterOptions?.adapterOptions?.usePost) {
      // Do exactly as the super call does in JSONAPIAdapter, but we'll use POST for the method.
      const url = this.buildURL(type.modelName, null, null, 'query', query)
      if (this.sortQueryParams) query = this.sortQueryParams(query)

      return this.ajax(url, 'POST', { data: query })
    } else {
      return super.query(store, type, query)
    }
  }
}
